var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-notch"},[_c('div',{staticClass:"form-notch-leading"}),_c('div',{staticClass:"form-notch-middle"}),_c('div',{staticClass:"form-notch-trailing"})])
}]

export { render, staticRenderFns }